import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/whw/Desktop/fugufish/vgw-website/frontend/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
